import { Text } from '@chatsdet/ui';
import { summarizeStepProgress, type StepOutcome } from './stepModel';

const SEGMENT_TONE: Record<StepOutcome, string> = {
  passed: 'bg-success',
  failed: 'bg-destructive',
  flaky: 'bg-warning',
  skipped: 'bg-muted-foreground/30',
};

/** One segment per step, coloured by outcome, with the totals spelled out beside it. */
export function ExternalStepProgress({ outcomes }: { outcomes: StepOutcome[] }) {
  if (outcomes.length === 0) return null;
  const progress = summarizeStepProgress(outcomes);
  return (
    <div
      className="flex shrink-0 flex-wrap items-center gap-x-4 gap-y-1 border-b border-border bg-card px-4 py-2"
      data-testid="step-progress"
    >
      <div
        className="flex h-2 min-w-[160px] flex-1 gap-px overflow-hidden rounded-sm"
        role="img"
        aria-label={`${progress.passed} passed, ${progress.failed} failed, ${progress.flaky} flaky, ${progress.skipped} skipped of ${progress.total} steps`}
      >
        {outcomes.map((outcome, i) => (
          <span key={i} className={`h-full min-w-[2px] flex-1 ${SEGMENT_TONE[outcome]}`} />
        ))}
      </div>
      <Text size="xs" className="tabular-nums text-muted-foreground">
        {progress.passed} passed · {progress.failed} failed ·{' '}
        {progress.flaky > 0 ? `${progress.flaky} flaky · ` : ''}
        {progress.skipped} skipped
      </Text>
      {progress.firstFailedNumber !== null ? (
        <Text size="xs" weight="medium" className="tabular-nums text-destructive">
          Failed at step {progress.firstFailedNumber} of {progress.total}
        </Text>
      ) : null}
    </div>
  );
}
